import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { NumberControlProps } from './NumberControl.interfaces';
import { Caption } from 'app/components/Caption';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useStyles } from './NumberControl.styles';
import { useNumberControl } from 'app/shared/hooks/controls/useNumberControl';

export default function NumberControl(props: NumberControlProps) {
  const classes = useStyles();

  const {
    input,
    meta,
    label,
    subLabel,
    helperText,
    tooltip,
    inlineTooltip,
  } = props;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    isValueCheckVisible,
    onFocus,
  } = useNumberControl(props);

  const renderCaption = () => {
    return inlineTooltip ? (
      <Caption
        classes={{
          root: classes.caption,
        }}
        text={inlineTooltip}
      />
    ) : null;
  };

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        floating
        tooltip={tooltip}
        floated={focused || UtilService.hasValue(input.value)}
        helperText={helperText}
        meta={meta}
        focused={focused}
      >
        <TextField
          {...input}
          id={input.name}
          type="number"
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={onFocus}
          label={subLabel ? `${label} - ${subLabel}` : label}
          className={classes.control}
          InputProps={{
            startAdornment: isValueCheckVisible && <DoneAdornment />,
          }}
          variant={'outlined'}
          margin={'dense'}
          error={error}
        />
        {renderCaption()}
      </ControlContainer>
    </FormControl>
  );
}
